<div class="asset-details-root">
  <div class="asset-details-header">
    <div class="row">
      <div class="asset-header-info col-6">
        <div class="header-info-column">
          <div class="header-title">
            <b>{{ customerHeaderInfo.tenantName ? customerHeaderInfo.tenantName : ('COMMON.NO_NAME' | translate) }}</b>
          </div>
          <div class="header-info-line">
            <span class="light-gray-text">
              {{ customerHeaderInfo.slrn ? customerHeaderInfo.slrn : ('COMMON.NO_SLRN' | translate) }}
            </span>
            <span class="pill header-pill" [ngClass]="{
                'green-success-pill': isComplete(),
                'red-failure-pill': isRejected(),
                'light-gray-pill': isPending(),
                'light-orange-pill': isAssigned()
              }">
              {{ getCustomerStatusTranslationKey() | translate }}
            </span>
            <span class="pill header-pill asset-type-pill" *ngIf="customer.buildingType">
              {{ 'COMMON.BUILDING_TYPE.' + customer.buildingType | uppercase | translate }}
            </span>
            <span class="pill header-pill" *ngIf="customer.id"
              [ngClass]="customer.isNew ? 'green-success-pill' : 'asset-type-pill'">
              {{ (customer.isNew ? 'COMMON.NEW_ENTRY' : 'COMMON.EXISTING') | translate }}
            </span>
          </div>
        </div>
        <div class="header-info-column light-gray-text">
          <div>{{ customerHeaderInfo?.email | hasValue }}</div>
          <div>{{ customerHeaderInfo?.phoneNumber | hasValue }}</div>
          <div>{{ customerHeaderInfo?.physicalAddress | hasValue }}</div>
        </div>
      </div>
      <div class="header-actions col" *ngIf="!onlyView">
        <button class="btn asset-header-action-button" (click)="regularize()"
          *ngIf="customer.accountNumber == '' && customer.isNew && isRegularizationUploadVisible && permissionsService.isCustomerRegularizationAllowed">
          {{ 'CUSTOMER_DETAILS.REGULARIZE' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#assignToFieldAgent"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged);"
          *ngIf="permissionsService.isCustomerRetagAllowed">
          {{ 'COMMON.RETAG' | translate }}
        </button>
        <div class="recall-container position-relative d-inline-block" *ngIf="
            permissionsService.isCustomerRecallAssignedAllowed ||
            permissionsService.isCustomerRecallValidatedAllowed
          ">
          <button class="btn asset-header-action-button" (click)="showRecallMenu = !showRecallMenu">
            {{ 'COMMON.RECALL' | translate }}
          </button>
          <div *ngIf="showRecallMenu" class="recall-options shadow-sm" @slideToggle>
            <div class="recall-type" [ngClass]="!recallAssignedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallAssignedAllowed ? recallAssigned() : null">
              <span>{{ 'COMMON.ASSIGNED_TASK' | translate }}</span>
            </div>
            <div class="recall-type" [ngClass]="!recallValidatedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallValidatedAllowed ? recallValidation() : null">
              <span>{{ 'COMMON.VALIDATED_TASK' | translate }}</span>
            </div>
          </div>
        </div>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#updateStatus"
          [disabled]="disableUpdateStatusButton()" (click)="updateStatusClicked = true"
          *ngIf="permissionsService.isCustomerApproveRejectAllowed">
          {{ 'COMMON.UPDATE_STATUS' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#auditReview"
          [disabled]="disableAuditReviewButton()" *ngIf="permissionsService.isCustomerAuditReviewAllowed">
          {{ 'COMMON.FIELD_AUDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#review"
          [disabled]="disableReviewButton()" *ngIf="permissionsService.isCustomerReviewAllowed">
          {{ 'COMMON.REVIEW_BUTTON' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#assignToFieldAgent"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned);"
          *ngIf="permissionsService.isCustomerAssignAllowed">
          {{ 'COMMON.ASSIGN_AGENT' | translate }}
        </button>
        <button class="btn asset-header-action-button" *ngIf="!editEnabled && permissionsService.isCustomerCreateEditAllowed"
          (click)="edit()">
          {{ 'COMMON.EDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button asset-header-save-button" *ngIf="editEnabled"
          (click)="openEditModal()">
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="asset-details-content">
    <div class="row">
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12"
          [ngClass]="customerInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'COMMON.CUSTOMER.INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="customerInfoCardExpanded = !customerInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="customerInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="customerInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.SLRN' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.building.slrn | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('TenantName')">{{ customer.tenantName | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('TenantName')" class="form-control" [(ngModel)]="customer.tenantName" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_OWNER' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('BuildingOwner')">{{ customer.buildingOwner | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('BuildingOwner')" class="form-control" [(ngModel)]="customer.buildingOwner" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.accountNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ID_CARD_NUM' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('CardNumber')">{{ customer?.cardNumber | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('CardNumber')" class="form-control" [(ngModel)]="customer.cardNumber" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PHONE_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('PhoneNumber')">{{ customer.phoneNumber | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('PhoneNumber')" class="form-control" [(ngModel)]="customer.phoneNumber" pattern="[0-9]+" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.EMAIL' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('Email')">{{ customer?.email | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('Email')" class="form-control" [(ngModel)]="customer.email" type="email" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.address | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PHYSICAL_ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.physicalAddress | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CLOSEST_LANDMARK' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.building?.closestLandmark | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="permissionsService.isCustomerElectricalAddressCodeAllowed">
              <div (click)="switchElectricalAddressFormat()" class="col-5 asset-card-content-title property-code-switch">
                {{ (isCinEnabled ? 'COMMON.MBC_DETAILS.CIN' : 'COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS') | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ (isElectricalAddressLong ? customer.electricalAddressLong : customer.electricalAddress) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.BU.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.geographicalRegionName : customer.area?.regionName) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.UT.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.subGeographicalRegionName : customer.area?.name) | hasValue }}
              </div>
            </div>
            <ng-container *ngIf="isGhanaPostFieldsVisible">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_CODE' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ customer.ghanaPostGps | hasValue }}</div>
              </div>
              <div class="asset-card-info row" *ngIf="customer.postCodeException">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_CODE_EXC' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ customer.postCodeException | hasValue }}</div>
              </div>
            </ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.GEO_LOCATION' | translate }}</div>
              <div class="col-6 asset-card-content-value">
                {{ customer.building.latitude }}, {{ customer.building.longitude }}
              </div>
              <div class="geo-icon col-1" (click)="showCustomerLocation()" data-bs-toggle="modal"
                data-bs-target="#showMap">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                    fill="var(--primary-color)" />
                </svg>
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="isGeoCodeVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.GEO_CODE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.geoCode | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_INSPECTION' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('CustomerInspectionConclusion')">{{ customer?.customerInspectionConclusion | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('CustomerInspectionConclusion')" class="form-control" [(ngModel)]="customer.customerInspectionConclusion" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REMARKS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer.remarksAndRecommendations | hasValue }}</div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12"
          [ngClass]="buildingInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'BUILDINGS.INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="buildingInfoCardExpanded = !buildingInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="buildingInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="buildingInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_STRUCTURE.NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer.building.buildingStructure | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_DEVELOPMENT.NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer.building.buildingDevelopmentStage | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.NUMBER_IN_HOUSE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('NumberOfHouseholds')">{{ customer?.numberOfHouseholds | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('NumberOfHouseholds')" class="form-control" type="number" [(ngModel)]="customer.numberOfHouseholds"
                  pattern="[0-9]+" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.USE_OF_PREMISES' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer?.buildingType?.toString() | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PREMISE_TYPE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isPermiseTypeEditable">{{ customer?.permiseType | hasValue }}</ng-container>
                <select *ngIf="isPermiseTypeEditable" class="form-control" [(ngModel)]="customer.permiseType"
                  (change)="selectPermiseType()">
                  <option *ngFor="let option of permiseOptions" [ngValue]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PREMISE_CATEGORY' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('PermiseCategory')">{{ customer?.permiseCategory | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('PermiseCategory')" class="form-control" [(ngModel)]="customer.permiseCategory">
                  <option *ngFor="let option of permiseCategoryOptions" [ngValue]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ACTIVITY' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isActivityEditable">{{ customer?.activity | hasValue }}</ng-container>
                <select *ngIf="isActivityEditable" class="form-control" [(ngModel)]="customer.activity"
                  (change)="selectActivity()">
                  <option *ngFor="let option of activityOptions" [ngValue]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.SUB_ACTIVITY' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('SubActivity')">{{ customer?.subActivity | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('SubActivity')" class="form-control" [(ngModel)]="customer.subActivity">
                  <option *ngFor="let option of subactivityOptions" [ngValue]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.NEIGHBORHOOD' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('Neighborhood')">{{ customer?.neighborhood | enumTranslate | translate }}</ng-container>
                <select *ngIf="isStaticEditable('Neighborhood')" class="form-control" [(ngModel)]="customer.neighborhood">
                  <option *ngFor="let option of neighborhoodOptions" [ngValue]="neighborhood[option.key]">
                    {{ option.value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="customer.buildingType.toString() == 'Residential'">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.NUMBER_OF_ROOMS' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('NumberOfRooms')">{{ customer?.numberOfRooms | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('NumberOfRooms')" class="form-control" [(ngModel)]="customer.numberOfRooms">
                  <option *ngFor="let option of numberOfRoomsOptions" [ngValue]="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="customer.propertyCode != ''">
              <div (click)="switchPropertyCodeFormat()" class="col-5 asset-card-content-title property-code-switch">
                {{ 'COMMON.MBC_DETAILS.PROPERTY_CODE' | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ (isPropertyCodeShort ? customer.propertyCodeShort : customer.propertyCode) | hasValue }}
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12"
          [ngClass]="networkInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'TRANSFORMERS.EDIT.NETWORK_INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="networkInfoCardExpanded = !networkInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="networkInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="networkInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.POLE.CONNECTED_LT_POLE' | translate }}</div>
              <div class="col-7 asset-card-content-value conn-assets">
                {{ customer.building.poleSlrn | hasValue }}
                <img *ngIf="customer.building?.poleId" (click)="viewConnectedAssets(1)" title="View"
                  src="assets/icons/angles-right.svg">
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.substation?.feederName : customer.dt?.feeder?.name) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.substation?.feederNumber : customer.dt?.feeder?.number) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.substation?.dtName : customer.dt?.name) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ (hasCimDataIntegration ? customer.substation?.dtNumber : customer.dt?.number) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CONNECTED_SERVICE_WIRE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.connectedServiceWire | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.TYPE_OF_CONNECTION' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer?.typeOfConnection | enumTranslate | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12" *ngIf="permissionsService.hasDashboardConfigEnergySources && countOfEnergySource"
          [ngClass]="energySourceCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-7">
              {{ 'COMMON.CUSTOMER.ENERGY_SOURCE.CONNECTED' | translate }}
              <span class="light-gray-text">{{ currentEnergySourcePage + 1 }} / {{ countOfEnergySource }}</span>
            </h2>
            <div class="collapse-arrow col-5">
              <button class="action-button" (click)="previousEnergySource()">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 9L1 5L5 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <button class="action-button" (click)="nextEnergySource()">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L5 5L1 9" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <button class="action-button" (click)="energySourceCardExpanded = !energySourceCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="energySourceCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="energySourceCardExpanded && currentEnergySource" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.CUSTOMER.ENERGY_SOURCE.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ currentEnergySource.energySourceType?.toString() | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_STATUS' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ currentEnergySource.meterStatus?.toString() | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_CONDITION' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ currentEnergySource.meterCondition?.toString() | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentEnergySource.meterBrand | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentEnergySource.meterNumber | hasValue }}</div>
            </div>
            <ng-container *ngIf="currentEnergySource.energySourceType?.toString() == 'Solar'">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.CUSTOMER.ENERGY_SOURCE.SOLAR_CAPACITY' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ currentEnergySource.solarInfo?.solarCapacity | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.CUSTOMER.ENERGY_SOURCE.INVERTER_OEM' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ currentEnergySource.solarInfo?.inverterOem | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.CUSTOMER.ENERGY_SOURCE.STORAGE_CAPACITY' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ currentEnergySource.solarInfo?.storageCapacity | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.CUSTOMER.ENERGY_SOURCE.INVERTER_CAPACITY' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ currentEnergySource.solarInfo?.inverterCapacity | hasValue }}</div>
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="customer.customerHistories != null && customer.customerHistories.length > 0"
          class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'COMMON.HISTORY' | translate }}</h2>
          </div>
          <div class="asset-card-content">
            <ng-container *ngFor="let history of customer.customerHistories">
              <div class="asset-card-info row" *ngIf="history.values.length > 0">
                <div class="col-5 asset-card-content-title">{{ history.label | translate }}</div>
                <div class="col-7 asset-card-content-value">
                  <div *ngFor="let item of history.values">{{ item }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="isDataQuality && customer.dataValidationReview != null && customer.dataValidationReview.length > 0"
          class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'COMMON.DATA_VALID_REVIEW' | translate }}</h2>
          </div>
          <div class="asset-card-content">
            <div class="asset-card-info row" *ngFor="let dq of customer.dataValidationReview">
              <div class="col-5 asset-card-content-title">{{ dq.key }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="dq.key != 'Reason for rejection'">{{ dq.value | hasValue }}</ng-container>
                <a *ngIf="dq.key == 'Reason for rejection'" class="link" data-bs-toggle="modal"
                  data-bs-target="#rejectionReason">{{ 'COMMON.VIEW' | translate | lowercase }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12"
          [ngClass]="meterInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'COMMON.MBC_DETAILS.METER_INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="meterInfoCardExpanded = !meterInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="meterInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="meterInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('MeterType')">{{ customer?.meter?.meterType?.name | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('MeterType')" class="form-control" [(ngModel)]="customer.meterTypeId">
                  <option *ngFor="let option of meterTypeOptions" [ngValue]="option.key">{{ option.value }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('MeterNo')">{{ customer?.meter?.number | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('MeterNo')" class="form-control" [(ngModel)]="customer.meter.number" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.OLD_METER_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.oldMeterNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="isSPNFieldVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.CONTRACT_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.contractNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="isServiceTypeFieldVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.SERVICE_TYPE.TITLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.serviceType | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_TYPE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('CustomerType')">{{ customer?.customerType | enumTranslate | translate }}</ng-container>
                <select *ngIf="isStaticEditable('CustomerType')" class="form-control" [(ngModel)]="customer.customerType">
                  <option *ngFor="let option of customerTypeOptions" [ngValue]="option.key">{{ option.value }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.SLT_STATUS.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('SltStatus')">{{ customer?.sltStatus?.value?.toString() | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('SltStatus')" class="form-control" [(ngModel)]="selectedSltStatus.key">
                  <option *ngFor="let option of sltOptions" [ngValue]="option.key">{{ option.value }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.TARIFF_CLASS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.tariffClass | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="isActualTariffFieldVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REC_ACT_TARIFF_CLASS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.actualTariffClass | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CLIENT_TYPE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('ClientType')">{{ customer?.clientType | enumTranslate | translate }}</ng-container>
                <select *ngIf="isStaticEditable('ClientType')" class="form-control" [(ngModel)]="customer.clientType">
                  <option *ngFor="let option of clientTypeOptions" [ngValue]="option.key">{{ option.value }}</option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_STATUS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.meterStatus | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_CONDITION' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer?.meterCondition?.toString() | enumTranslate | translate }}
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="isMeterSlrnFieldVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_SLRN' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.meterSlrn | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="isFrmMeterVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FRM_METER_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ customer?.frmMeterNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="isInstallationDateVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.INSTALLATION_DATE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer?.installationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="isReplacementDateVisible">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REPLACEMENT_DATE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                {{ customer?.replacementDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="permissionsService.hasDashboardConfigBillingIntegration">
              <div class="col-8 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PAYMENT_AND_VEND' | translate }}</div>
              <div class="col-4 asset-card-content-value">
                <a class="link" (click)="getPaymentAndVendFromBilling()" data-bs-toggle="modal"
                  data-bs-target="#paymentInfo">{{ 'COMMON.VIEW' | translate }}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12"
          [ngClass]="userActivityCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'MV_POLES.USER_ACTIVITY' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="userActivityCardExpanded = !userActivityCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="userActivityCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="userActivityCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_CREATION_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.building.creationDate | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.DATE_TYPE.TAGGED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.taggedDate | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.FIRST_CAPTURED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.firstCaptureUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_UPDATED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.lastUpdateUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.UPDATED_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">
                {{ customer.lastUpdateTime | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.building.reassignedBy | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ customer.building.assignedUser | hasValue }}</div>
            </div>
            <ng-container *ngIf="permissionsService.isValidationStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.VALIDATION_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ getCustomerStatusTranslationKey() | enumTranslate | translate }}
                </div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ customer.validatedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.DATE_TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ customer.validatedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isAuditStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ customer.isAudited | enumTranslate:'Audit' | translate }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.AUDITED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ customer.auditedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ customer.auditedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isReviewStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ customer.isReviewed | enumTranslate:'Review' | translate }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REVIEWED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ customer.reviewedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ customer.reviewDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="asset-card col-12" [ngClass]="imagesCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'COMMON.IMAGES' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="imagesCardExpanded = !imagesCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="imagesCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="imagesCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.FRONT' | translate }}</div>
              <div class="col-12 images-list">
                <app-image-section *ngFor="let index of [0,1,2]" [image]="getFrontViewImage(index)" [index]="index"
                  [imageType]="ImageType.Frontview" [editEnabled]="isStaticEditable('FrontViewPictures')"
                  [permission]="permissionsService.isCustomerCreateEditAllowed" [inputId]="'fileFw' + index"
                  (imageClick)="showImage(ImageType.Frontview, index)" (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.MOUNTED_TAG' | translate }}</div>
              <div class="col-12 images-list single-image-list">
                <app-image-section [image]="getBuildingMountedImage()" [index]="0" [imageType]="ImageType.MountedTag"
                  [editEnabled]="isStaticEditable('BuildingTagMountedPicture')" [inputId]="'fileMounted' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed"
                  (imageClick)="showImage(ImageType.MountedTag)" (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-4 image-item">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.BILL' | translate }}</div>
                <app-image-section [image]="customer.billImageUrl" [index]="0" [imageType]="ImageType.Bill"
                  [editEnabled]="isStaticEditable('BillPicture')" [inputId]="'fileBill' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Bill)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
              <div class="col-4 image-item">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.ID_CARD' | translate }}</div>
                <app-image-section [image]="customer.cardImageUrl" [index]="0" [imageType]="ImageType.Card"
                  [editEnabled]="isStaticEditable('IdCardPicture')" [inputId]="'fileCard' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Card)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
              <div class="col-4 image-item" *ngIf="isCustomerMountedTagVisible">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.CUSTOMER_TAG' | translate }}</div>
                <app-image-section [image]="customer.meterImageUrl" [index]="0" [imageType]="ImageType.Meter"
                  [editEnabled]="isStaticEditable('CustomerTagPicture')" [inputId]="'fileCustomerTag' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Meter)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
              <div class="col-4 image-item" *ngIf="isImageMeterFieldVisible">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.METER_NUMBER' | translate }}</div>
                <app-image-section [image]="customer.meterNumberImageUrl" [index]="0" [imageType]="ImageType.MeterNumber"
                  [editEnabled]="isStaticEditable('MeterNumberPicture')" [inputId]="'fileMeter2' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed"
                  (imageClick)="showImage(ImageType.MeterNumber)" (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
              <div class="col-4 image-item" *ngIf="isBackViewPictureFieldVisible">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.CARD_BACK' | translate }}</div>
                <app-image-section [image]="customer.backCardViewImageUrl" [index]="0"
                  [imageType]="ImageType.CardBackViewImage" [editEnabled]="isStaticEditable('CardBackViewPicture')" [inputId]="'fileCardBack' + 0"
                  [permission]="permissionsService.isCustomerCreateEditAllowed"
                  (imageClick)="showImage(ImageType.CardBackViewImage)" (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
              <div class="col-4 image-item" *ngIf="isNewMeterPictureVisible && customer.newMeterPictureUrl">
                <div class="asset-card-content-title">{{ 'COMMON.PICTURES.NEW_METER_PICTURE' | translate }}</div>
                <app-image-section [image]="customer.newMeterPictureUrl" [index]="0"
                  [imageType]="ImageType.MeterReplacementReadingImage" [editEnabled]="isStaticEditable('NewMeterPicture')"
                  [inputId]="'fileNewMeter' + 0" [permission]="permissionsService.isCustomerCreateEditAllowed"
                  (imageClick)="showImage(ImageType.MeterReplacementReadingImage)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <lib-section-instance-card *ngFor="let section of sectionInstances" [section]="section"
          [editEnabled]="editEnabled" [editableAttributeIds]="editableAttributeIds" [editedValues]="editedValues"
          (mapClicked)="setClickedLocation($event)">
        </lib-section-instance-card>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="assetAssignType == AssetAssignType.Assigned" class="modal-title">{{ 'COMMON.ASSIGN_AGENT' | translate }}</h5>
        <h5 *ngIf="assetAssignType == AssetAssignType.Retagged" class="modal-title">{{ 'COMMON.RETAG_TASK' | translate }}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
            class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
          <label for="floatingInput">{{ 'COMMON.FIELD_AGENT' | translate }}</label>

          <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)" *ngFor="let u of mobileUsers">
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="assignTask()">
          <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{ 'COMMON.ASSIGN_TASK' | translate }}</span>
          <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{ 'COMMON.RETAG_TASK' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url" [thumbImage]="selectedImage?.url"
            [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">&lt;</button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">&gt;</button>
        </div>
        <app-image-geo-info [image]="selectedImage"
          (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isMapVisible" [longitude]="mapLongitude"
          [latitude]="mapLatitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.DATA_VALID_REVIEW' | translate }}</h5>
        <button type="button" #closeDQModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <div class="modal-body">
        <app-data-quality (closeModal)="cancelModal($event)" (closeRedirectModal)="closeRedirectModal()"
          assetType="Customer" [assetId]="customerId" [areaId]="customer.area.id"
          *ngIf="updateStatusClicked"></app-data-quality>
      </div>
    </div>
  </div>
</div>

<app-audit-review-customer (closeModal)="cancel($event)" assetType="Customer"
  [assetId]="customerId"></app-audit-review-customer>

<div class="modal" id="rejectionReason" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.REASON_FOR_REJECT' | translate }}</h5>
      </div>
      <div class="p-4">{{ modalRejectionReason }}</div>
      <button type="button" class="btn btn-primary w-50 mx-auto" data-bs-dismiss="modal" aria-label="Close">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal" id="paymentInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.MBC_DETAILS.PAYMENT_AND_VEND' | translate }}</h5>
      </div>
      <div class="asset-card-content m-4">
        <ng-container *ngIf="customer.customerType?.toString() == 'Prepaid'">
          <div class="asset-card-info row">
            <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_VEND_AMOUNT' | translate }}</div>
            <div class="col-7 asset-card-content-value">{{ customer?.lastVendAmount | hasValue }}</div>
          </div>
          <div class="asset-card-info row">
            <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_VEND_DATE' | translate }}</div>
            <div class="col-7 asset-card-content-value">{{ customer?.lastVendDate | hasValue }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="customer.customerType?.toString() == 'Postpaid'">
          <div class="asset-card-info row">
            <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_PAYMENT_AMOUNT' | translate }}</div>
            <div class="col-7 asset-card-content-value">{{ customer?.lastPaymentAmount | hasValue }}</div>
          </div>
          <div class="asset-card-info row">
            <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_PAYMENT_DATE' | translate }}</div>
            <div class="col-7 asset-card-content-value">{{ customer?.lastPaymentDate | hasValue }}</div>
          </div>
          <div class="asset-card-info row">
            <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CURRENT_DEBT' | translate }}</div>
            <div class="col-7 asset-card-content-value">{{ customer?.currentDebtBalance | hasValue }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="review" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.REVIEW' | translate }}</h5>
        <button type="button" #closeReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <app-review (closeModal)="cancelReviewModal($event)" assetType="Customer" [assetId]="customerId"></app-review>
    </div>
  </div>
</div>

<button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
  hidden></button>
<app-history (update)="updateHistory($event)"></app-history>
